import { render, staticRenderFns } from "./VirtualAccountForm.vue?vue&type=template&id=75b61953&lang=pug"
import script from "./VirtualAccountForm.vue?vue&type=script&lang=js"
export * from "./VirtualAccountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports